export function optimizedSearchQuery(value: string, prevValue: string, isShopify: boolean) {
  if (value.length === 1 && !prevValue && !isShopify) {
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    return capitalizedValue;
  } else {
    return value;
  }
}
